// extracted by css-extract-rspack-plugin
export default {"form":"MoveDialogForm-module__form__k3MgbvV","autoComplete":"MoveDialogForm-module__autoComplete__LJehl8Y","datePickerAnchor":"MoveDialogForm-module__datePickerAnchor__OGsULPF"};